const NAME = 'SENDBIRD';

export const getCreatedChannel = (store) => store[NAME].channel.create.data;
